module.exports = __webpack_public_path__ + "static/img/WHCHATPAY.651d356d.png";